export const NANO_ID_SLUGS = {
  AUTH_CONFIG: {
    PREFIX: "ac_",
    LENGTH: 12,
  },
  CONNECTED_ACCOUNT: {
    PREFIX: "ca_",
    LENGTH: 12,
  },
  TRIGGER_INSTANCE: {
    PREFIX: "ti_",
    LENGTH: 12,
  },
  ORG: {
    PREFIX: "ok_",
    LENGTH: 12,
  },
  PROJECT: {
    PREFIX: "pr_",
    LENGTH: 12,
    BACKWARD_COMPATIBILITY_PREFIX: "pk_",
  },
} as const;
